/*
 * @Author: WLL
 * @Date: 2020-04-29 14:06:28
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-01 19:12:22
 * @Description: 机构预测排行页面接口
 */
import http from "@/utils/http";

export default {
  async getAgencyList(params) {
    return await http.post("predict/agency/agency_list", params);
  },
  async getRateLineData(params) {
    return await http.post("predict/agency/rate_return", {
      pageNo: 1,
      pageSize: null,
      ...params
    });
  },
  async getAgencyReport(params) {
    return await http.post("predict/agency/report", params);
  }
};
